import moment from 'moment-timezone';

const EXCEL_FILENAME = 'Blue Sky Compliance';

export const CreateExcelFileName = (symbol) => {
    const currentDateTime = new Date();
    const currentDate = moment(currentDateTime).format('YYYY-MM-DD');
    const formattedTitle = symbol + ' ' + EXCEL_FILENAME;
    return `${formattedTitle} as of ${currentDate}.xlsx`;
};